
import Vue from "vue";
import { Sale, SaleHistory } from "@/models/base";
import AppSaleHistoryEventSentInfo from "./SaleHistoryEventSentInfo.vue";


export default Vue.extend({
	props: {
		event: {
			type: Object as ()=>SaleHistory,
			required: true
		},
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		originalEventId():number {
			return parseInt(this.event.Props[0]);
		},
		originalEvent():SaleHistory | undefined{
			if (Number.isNaN(this.originalEventId)) return undefined;
			return this.sale.History.find(e=>e.ID == this.originalEventId);
		}
	},
	components: {
		AppSaleHistoryEventSentInfo
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
